<template>
  <!-- App -->
  <div id="app">
    <!-- Main Views -->
    <f7-views>
      <f7-view id="main-view" navbar-fixed main domCache>
        <!-- Pages -->
        <f7-pages>
          <!--<bc-launch-screen></bc-launch-screen>-->
        </f7-pages>
        <add-to-homescreen-adaptive
          v-if="!isMobileAlone && isAddHomeScreenShow"
        ></add-to-homescreen-adaptive>
        <add-homescreen-button
          v-if="!isMobileAlone && !isAddHomeScreenShow"
        ></add-homescreen-button>
      </f7-view>
    </f7-views>
    <!--<login-modal @afterAuthVerifiedActions="afterAuthVerifiedActions"></login-modal>-->
    <!--<div class="modal-overlay js-overlay-handler close-picker" :class=" {'modal-overlay-visible' : isModalOpen}"></div>-->
    <!-- Login Screen -->
    <notifications
      :group="notificationsGroup"
      position="bottom right"
      :max="3"
    />
  </div>
</template>

<script>
/* eslint-disable */

import LaunchScreen from "./launch-screen.page.vue";
import BcLaunchScreen from "./launch-screen.page.vue";
import PrivacyPolicy from "../components/privacy-policy";
import TermsOfUse from "../components/terms-of-use";
import { DEF_GROUP } from "@/shared/notifications.js";
import { mapState } from "vuex";

export default {
  components: {
    BcLaunchScreen,
    "bc-launch-screen": LaunchScreen,
    "terms-of-use": TermsOfUse,
    "privacy-policy": PrivacyPolicy,
  },
  async mounted() {
    this.loaded = true;
  },
  data() {
    return {
      notificationsGroup: DEF_GROUP,
    };
  },
  computed: {
    ...mapState({
      isDemoUser: (state) => state.editUserProfile.customerUser.isDemoUser,
      isAddHomeScreenShow: (state) => state.standalone.isAddHomeScreenShow,
    }),
    isMobileAlone() {
      if (this.$store.state.standalone.isMobile) {
        return this.$store.state.standalone.isStandalone;
      } else return true;
    },
  },
};
</script>
<style scoped>
.substrate {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 10000;
}
.substrate input {
  margin: 0 auto;
  position: absolute;
  bottom: 30%;
  width: 200px;
  height: 50px;
  background-color: #f5f636;
  outline: none;
  border: 0px;
  border-radius: 20px;
  left: calc(50% - 100px);
  font-size: 18px;
}
.substrate div {
  color: #fff;
  width: 250px;
  position: absolute;
  left: calc(50% - 125px);
  font-size: 20px;
  bottom: 5%;
}
.policy {
  overflow: auto;
  height: 95vh;
  padding: 25px;
}
.policy h2 {
  text-align: center;
}
/* .substrate div a{
    color:#3096BC
  } */
</style>



// WEBPACK FOOTER //
// app.vue?6ada0df5